import PropTypes from 'prop-types'
import EventEmitter, { SHOW_POPUP_UPGRADE } from '../helpers/EventEmitter'

export const LockAction = ({ children, enable }) => {
  const onClick = () => {
    EventEmitter.dispatch(SHOW_POPUP_UPGRADE)
  }

  return enable ? (
    <div className="dFlex alignItemsCenter" onClick={onClick}>
      {children}
    </div>
  ) : (
    children
  )
}

LockAction.propTypes = {
  children: PropTypes.node.isRequired,
}
